import React, { useState } from "react";
import {
  deleteOption,
  deleteQuestion,
  updateOption,
  updateQuestion,
} from "../../services/referenceQuestionnaireService";
import {
  deleteCandidateOption,
  deleteCandidateQuestion,
  updateCandidateOption,
  updateCandidateQuestion,
} from "../../services/candidateQuestionnaireService";

interface EditQuestionModalProps {
  questionnaireType: string;
  itemID: number;
  text: string;
  type: "question" | "option";
  onClose: () => void;
}

const EditQuestionModal: React.FC<EditQuestionModalProps> = ({
  questionnaireType,
  itemID,
  text,
  type,
  onClose,
}) => {
  const [editedText, setEditedText] = useState(text);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSave = async () => {
    try {
      setLoadingSpinner(true);
      if (questionnaireType === "reference") {
        if (type === "question") {
          await updateQuestion(itemID, editedText);
        } else {
          await updateOption(itemID, editedText);
        }
      } else if (questionnaireType === "candidate") {
        if (type === "question") {
          await updateCandidateQuestion(itemID, editedText);
        } else {
          await updateCandidateOption(itemID, editedText);
        }
      }

      onClose();
    } catch (error) {
      console.error("Error updating:", error);
      setErrorMessage("Failed to update. Try again.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoadingSpinner(true);
      if (questionnaireType === "reference") {
        if (type === "question") {
          await deleteQuestion(itemID);
        } else {
          await deleteOption(itemID);
        }
      } else if (questionnaireType === "candidate") {
        if (type === "question") {
          await deleteCandidateQuestion(itemID);
        } else {
          await deleteCandidateOption(itemID);
        }
      }

      onClose();
    } catch (error) {
      console.error("Error deleting text:", error);
      setErrorMessage("");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={onClose}></div>
      <div className="filter-popup-large">
        <div className="close-button-container">
          <button className="close-button" onClick={onClose}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Edit {type === "question" ? "Question" : "Option"}</h2>
        </div>
        <textarea
          value={editedText}
          onChange={(e) => setEditedText(e.target.value)}
          rows={6}
          style={{ width: "100%" }}
          maxLength={500}
        />
        <div
          style={{
            fontSize: "14px",
            marginTop: "4px",
            textAlign: "right",
          }}
        >
          {editedText?.length ?? 0}/500
        </div>
        {errorMessage && (
          <div className="error-message" style={{ color: "red" }}>
            {errorMessage}
          </div>
        )}
        <div className="filter-actions">
          <button className="oxbtn btn-green" onClick={handleSave}>
            Save
          </button>
          <button className={`oxbtn btn-red`} onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default EditQuestionModal;
